<template>
  <div :class="$route.fullPath!='/home'?'footer':'footer-bg'">
    <div class="container w">
      <div class="footer-info">
        <p class="copyright">Copyright © 2022 医小智（日照）工业互联网有限公司 版权所有</p>
        <div class="icp-row">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37110202371204" rel="noreferrer" target="_blank">鲁公网安备37110202371204</a>
          <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2022031907号-1</a>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802033469">鲁B2-20240306</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import YButton from '/components/YButton'
export default {
  data() {
    return {}
  },
  methods: {
    openService() {
      this.$notify({
        title: '离线帮助',
        message: '系统正在维护中，暂时无法为您提供帮助，如有紧急事项请联系400 088 3316',
        type: 'warning'
      })
    },
    openAgree(id) {
      if(id==24){
        let routeUrl = this.$router.resolve({path: '/downLoad'})
        window.open(routeUrl.href, '_blank');
      }else{
        let url = this.$router.replace({
          name:'agreement',
          query: {agreeId:id},
        })
        window.open(url,'_self')
      }
    }
    /*
     openAgree(id) {
       // window.open('//' + window.location.host + '/#/agreement?agreeId=' + id)
       let url = this.$router.replace({
         name:'agreement',
         query: {agreeId:id},
       })
       window.open(url,'_self')
     }
    */
  },
  watch: { '$route' (to, from) {
      window.location.reload();
    },
  },
  components: {
    YButton,
  }
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 15px 0;
  background: #1890ff;
  margin: 0 calc(-50vw + 50%);

  .copyright {
    font-size: 13px;
    font-weight: 500;
    color: #fff;
    margin: 0;
  }

  .icp-row {
    display: flex;
    gap: 16px;

    a {
      font-size: 12px;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      text-decoration: none;
      transition: color 0.2s ease;

      &:hover {
        color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// MFooter.vue?59eb066e